import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import PublicLayout from "../components/PublicLayout";

const fallbackContent = {
  "about-us": {
    title: "About Us",
    description: "<p>We help employers connect with the right talent and help candidates discover meaningful opportunities.</p>",
  },
};

const PublicCmsPage = () => {
  const { slug: routeSlug } = useParams();
  const slug = routeSlug || "about-us";
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const pageResponse = await axiosInstance.get(`/pages/public/${slug}`);
        setPage(pageResponse.data?.page || null);
      } catch (error) {
        setPage(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [slug]);

  const content = useMemo(
    () => page || fallbackContent[slug] || { title: "Page", description: "<p>Content coming soon.</p>" },
    [page, slug]
  );

  return (
    <PublicLayout>
      <Helmet>
        <title>{content.metaTitle || `${content.title} | YNB Jobs`}</title>
        <meta name="description" content={content.metaDescription || content.title} />
      </Helmet>

      {loading ? (
        <section className="portal-loader-shell">
          <div className="portal-container">
            <div className="portal-loader-card">
              <div className="portal-round-loader" role="status" aria-label="Loading page"></div>
              <h2 className="h5 fw-bold mb-2">Loading page...</h2>
              <p className="text-muted mb-0">Fetching content for this section.</p>
            </div>
          </div>
        </section>
      ) : (
        <section className="portal-section m-0 p-0">
       
       <div
                    className="portal-muted leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: content.description || "" }}
                  />
            
        </section>
      )}
    </PublicLayout>
  );
};

export default PublicCmsPage;
